module.exports = require('./helpers/bundle-url').getBundleURL('gj6jC') + "logo-dark.eefe0b7f.svg";